<template>
	<div>
		<div class="topbar">
			<div class="w1200 bc" style="margin:auto;">
				<ul class="topbar-right fr">
					<li v-if="isLogin==false">
						<a class="co2" :href="loginUrl">[登录]</a>
					</li>
					<li v-if="isLogin==false">
						<a class="co2" :href="registerUrl">[注册]</a>
					</li>
					<li v-if="isLogin==true">
					<span>您好</span>
					</li>
					<li v-if="isLogin==true">
						<a class="co2" :href="userCenterUrl">{{account}}</a>
					</li>
					<li v-if="isLogin==true">
						<a class="co2" @click="logout()">[退出]</a>
					</li>

					<li>
						<a :href="aboutUsUrl">关于我们</a>
					</li>
					<!--li v-if="isLogin==true">
						<a @click="jumpTo('address_list')">收货地址</a>
					</li-->
					<li>
						<a v-bind:href="contactUrl" target="_blank">联系客服</a>
					</li>
					<li>
						<a v-on:mouseenter="mobileAppShow()" v-on:mouseleave="mobileAppHidden()">手机商城</a>
						<div class="demensional_code" v-if="isShow">
							<img width="100px" src="../../../static/images/dimensional_code.png" />
						</div>
					</li>
				</ul>
				<ul class="topbar-left fl">
					<li>
						您好！欢迎来到相伴宝！
					</li>
					<li>
						<a class="co1" :href="indexUrl">返回相伴宝</a>
					</li>
				</ul>
			</div>
		</div>

<div class="clear"></div>
<div class="header">
	<div class="header line">
		<div class="w1200 bc" style="margin:auto;">
			<a class="logo fl" :href="indexUrl" title="云永云商城"></a>
			<div class="search">
				<span class="ico"></span>
				<input class="text" type="text" v-model="sortParam" placeholder="请输入关键字">
				<button class="btn" @click="findGoods()">搜商品</button>
				<button class="btn" @click="findShops()" style="margin-left: 3px;">搜店铺</button>
			</div>
			<div class="r-box fr" style="display: none;">
				<div class="mycart" @mouseenter="shopCarShow()" @mouseleave="shopCarHide()">
					<i class="ico-cart"></i>
					<a href="#">我的购物车</a>
					<span class="ico-shopping-amount">{{ shoppingCartNum }}</span>
					<i class="ico-r"></i>
					<div class="goods-list none" style="display: none;">
						<div class="spacer"></div>
						<!--没选商品-->
						<div v-if="shoppingCartNum == 0" class="no-goods">
							<img src="../../../static/images/settleup-nogoods.png" width="57" height="49">购物车中还没有商品，赶紧选购吧！
						</div>
						<!--已选商品-->
						<div v-if="shoppingCartNum > 0" class="mylist">
							<h4>最新加入的商品</h4>
							<ul>
								<!--<li class="li-1"><span class="fr">小计：￥599.00</span></li>-->
								<li class="li-2" v-for="bo in boList" v-bind:id="bo.goodsCode+'_cart_pro'" >
									<a class="fl spic" href="#"><img v-bind:src="bo.imgSmall" width="50" height="50"></a>
									<p class="name">
										<a href="#">{{ bo.goodsName }}</a> &nbsp;&nbsp;&nbsp;<span>数量：{{ bo.goodsNumber }}</span>
									</p>
									<p class="other"><span>￥{{ bo.goodsPrice }}</span><br>
										<a class="del"  v-on:click="deleteGoods(bo.goodsCode)">删除</a>
									</p>
								</li>
							</ul>
							<div class="fbar"><span class="fl ml10">共{{ count }}件商品　共计<b>￥ {{ sumMoney }}</b></span>
								<a class="fr gobuy" href="#">去购物车</a>
							</div>
						</div>
					</div>
				</div>
				<div v-if="isLogin==true" class="myorder ml25" @mouseenter="orderShow()" @mouseleave="orderHide()">
							<i class="ico-orders"></i>
							<a @click="goOrder('')">我的订单 <span class="ico-shopping-amount">{{ allCount }}</span></a></a>
							<i class="ico-r"></i>
							<div class="orders-list orders">
                		<ul>
                    		<li><a href="javascript:void(0)" @click="goOrder('wait_buyer_pay')">等待买家付款 <span class="ico-shopping-amount" style="text-align: center;">{{ payCount }}</span></a></li>
                        	<li><a href="javascript:void(0)" @click="goOrder('wait_send_goods')">等待卖家发货 <span class="ico-shopping-amount" style="text-align: center;">{{ sendCount }}</span></a></li>
                        	<li><a href="javascript:void(0)" @click="goOrder('wait_buyer_confirm_goods')">等待确认收货 <span class="ico-shopping-amount" style="text-align: center;">{{ putCount }}</span></a></li>
                        	<li><a href="javascript:void(0)" @click="goOrder('trade_finish')">订单完成 <span class="ico-shopping-amount" style="text-align: center;">{{ receiveCount }}</span></a></li>
                        	<li><a href="javascript:void(0)" @click="goOrder('trade_close')">订单关闭 <span class="ico-shopping-amount" style="text-align: center;">{{ closeCount }}</span></a></li>
                    	</ul>
                		</div>
						</div>
			</div>
		</div>
	</div>
</div>

<!--顶部：导航 开始-->
<!--<heardernav ref="navComp" :isRefresh="isRefresh"></heardernav>-->
<!--顶部：导航 结束-->

<div class="clear mt15"></div>
<div class="head">
        <div>
            <h2 class="head_logo left">
            	<img src="../../../static/images/head_logo.png" width="95px" style="margin-top: 6px;" alt="" />
            </h2>
            <div class="headRight headLeft left">
        	    <ul>
	                <li><a href="#">首页</a></li>
	                <!--<li><a href="#">品牌抢购</a></li>-->
	            </ul>
            </div>
            <div class="headRight right">
                <ul>
                    <li>
                        <img src="../../../static/images/smallLogo.png" alt="">
                        	限时限量抢
                    </li>
                    <li>
                        <img src="../../../static/images/smallLogo1.png" alt="">
                        30天低价
                    </li>
                    <li>
                        <img src="../../../static/images/smallLogo2.png" alt="">
                        全场包邮
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div style="background:#2C3847;" class="focus_nav" @mouseover="hoverShow()" @mouseout='hoverHide()'>
    	 <div id="navTime">
	    	 <div class="navTime">
		        <ul>
		        	<li  v-bind:class="{cur:seckillCode==secKillBo.activityCode}" @click="chooseActivity(secKillBo.activityCode,secKillBo.activityBeginTime,secKillBo.activityEndTime)">
										<p style="font-size: 17px;">{{secKillBo.activityBeginTime}}</p>
										<p class="nav_kq">已开抢</p>
					</li>
		            <li  v-for="(seckill,index) in secKillList" :key="seckill.id"  v-bind:class="{cur:seckillCode==seckill.activityCode}" @click="chooseActivity(seckill.activityCode,seckill.activityBeginTime,seckill.activityEndTime)">
										<p style="font-size: 17px;">{{seckill.activityBeginTime}}</p>
										<p class="nav_kq">即将开场</p>
					</li>
		        </ul> 
		    </div>
		    <div class="btn_nav">
		    	  <a href="javascript:void(0);" class="change-bnt prev-bnt" @click="prev_move()"><</a>
		 		  <a href="javascript:void(0);" class="change-bnt next-bnt" @click="next_move()">></a>	
		    </div>
	    </div>
    </div>
   
    <div class="shopWarp">
        <div class="shopBox">
            <ul>
                <li v-for="good in goodsList">
                	<a @click="toGoodsDetail(good.goodsCode)">
                    <img :src="good.imgMiddle" alt="" >
                    <div class="right">
                        <p class="rightTitle">{{good.goodsName}}</p>
                        <p class="rightdetail">{{good.goodsNameDesc}}</p>
                        <div class="priceleft">
                            <span class="originalPrice1" >￥{{(good.unitPrice/100).toFixed(2)}}</span>
                            <br>
                            <span class="currentPrice1" v-if="good.seckillPrice.length<6"><span style="font-size: 18px;font-weight: 500;">￥</span>{{(good.seckillPrice/100).toFixed(2)}}</span>
                            <span class="currentPrice1" v-else><span style="font-size: 18px;font-weight: 500;">￥</span>{{(good.seckillPrice/100).toFixed(0)}}</span>
                        </div>
                        <div class="priceright link-btn" v-if="compareActTime(activityBeginTime,activityEndTime)">
                            		马上抢
                        </div>
                        <div class="clear"></div>
                        <div class="progress" v-if="compareActTime(activityBeginTime,activityEndTime)">
                            <div class="num">
                                <span>已抢购{{(good.saleNumberTotal+good.inpSaleNumber+good.goodsNumber)==0?0:(((good.saleNumberTotal+good.inpSaleNumber)/(good.saleNumberTotal+good.inpSaleNumber+good.goodsNumber)*100).toFixed(0))}}%</span>
                                <span>已抢购{{good.saleNumberTotal+good.inpSaleNumber}}件</span>
                                <!--<span>还有{{good.goodsNumber}}件</span>-->
                            </div>
                            <div class="down">
                                <div v-bind:style="{'width':(good.saleNumberTotal+good.inpSaleNumber+good.goodsNumber)==0?'0%':(((good.saleNumberTotal+good.inpSaleNumber)/(good.saleNumberTotal+good.inpSaleNumber+good.goodsNumber)*100).toFixed(0)+'%')}"></div>
                            </div>
                        </div>
                    </div>
                    </a>
                </li>
                <!--<li>
                    <img src="images/shop1.png" alt="" >
                    <div class="right">
                        <p class="rightTitle">电子狗双镜头行车记录仪一体机</p>
                        <p class="rightdetail">标配也带电子狗</p>
                        <div class="priceleft">
                            <span class="originalPrice">￥1280</span><br>
                            <span class="currentPrice"><span style="font-size: 18px;font-weight: 500;">￥</span>729</span>
                        </div>
                        <div class="priceright link-btn">
                            马上抢
                        </div>
                        <div class="clear"></div>
                        <div class="progress">
                            <div class="num">
                                <span>已抢购51%</span>
                                <span>已抢购225件</span>
                            </div>
                            <div class="down">
                                <div></div>
                            </div>
                        </div>
                    </div>
                </li>-->
               
            </ul>
        </div>
    </div>

<div class="clear"></div>
<footermenu></footermenu>
		<footercopyright></footercopyright>
	</div>
</template>

<script>
	//import {jQuery} from "../../../static/js/jquery.min.js"
	import jQuery from 'jquery';
	import API from "../../../static/api/api.js"
	import {getImgUrl,dateFormat,getValueFromMap,showMoney,parseResult,getIndexUrl,getAboutUsUrl,getEmallUrl,getUcUrl,sysContactUrl,compareDate} from "../../../static/js/emallUtils.js"
	import dbmain from '../../../static/js/db-main.js'
	import Header from '@/components/Header'
	import FooterMenu from '@/components/FooterMenu'
	import FooterCopyright from '@/components/FooterCopyright'
	import HearderNav from '@/components/HearderNav'
	
	var colorListLength = 0;
	var listLength = 0;
	export default {
		name: 'goodsList',
		components: {
			'sortHeader':Header,
			'footermenu':FooterMenu,
			'footercopyright':FooterCopyright,
			'heardernav':HearderNav
		},
		data(){
            return {
            	isRefresh:true,
            	goodsList:[],
            	recommendGoodsList:[],
            	sortCondition:'defaultSort',
			    sortSaleAmount:'',
			    sortPublishTime:'',
			    sortPrice:'',
			    choosedCondItem:[],
		     	catCode:'categoryAll',
		     	interval:'intervalAll',
		     	sortTime:'timeAll',
		     	currentPage:1,
		     	totalPage:1,
		     	orderBy:'',
		     	orderAsc:'',
		     	shopCode:'',
		     	pageList:[1],
		     	totalItem:0,
		     	sortParam:'',
		     	shoppingCartNum:0,
				boList:[],
				count:0,
				goodsImgs:[],
				sumMoney:0,
				goodsName:'',
				firstCatCode:'',
				shopCode:'',
				mobile:'',
				isLogin:false,
			    isShow:false,
			    account:'',
			     userCenterUrl:'',
				loginUrl:'',
				registerUrl:'',
				logoutUrl:'',
				aboutUsUrl:'',
				indexUrl:'',
				orderUrl:'',
				catNameCn:'',
				brandId:0,
				brandName:'',
				allCount:0,
				payCount:0,
				putCount:0,
				receiveCount:0,
				sendCount:0,
				closeCount:0,
	   			computeFlag:'',
				contactUrl:'',
				showItem:7,
				isInit:false,
				lower:'',
				upper:'',
				activityBeginTime:'',
				activityEndTime:'',
				secKillBo:'',
				secKillList:[],
				seckillCode:'',
				moveLetf:0,
				moveRight:0,
				currentDate:null//系统当前时间
            }
       },
        methods:{
        	prev_move:function(){
        		if(listLength + this.secKillList.length >4){
        			listLength --;
        			colorListLength -= 100;
        			jQuery('.navTime ul').animate({"margin-left":colorListLength+"px"},200);
        		}
        	},
        	next_move:function(){
        		if(colorListLength<400){
			        colorListLength += 100;
			        listLength ++;
	        		jQuery('.navTime ul').animate({"margin-left":colorListLength+"px"},200);
        		}
        	},
        	hoverShow:function(){
        	    jQuery('.btn_nav').show();
        	},
        	hoverHide:function(){
        		 jQuery('.btn_nav').hide();
        	},
        	orderShow:function(){
				jQuery(".orders-list").show();
			},
			orderHide:function(){
				jQuery(".orders-list").hide();
			},
			shopCarShow:function(){
				jQuery(".goods-list").show();
			},
			shopCarHide:function(){
				jQuery(".goods-list").hide();
			},
        	getOrderCount:function(shopCode){
        		var that=this;
        		API.getOrderCount(function(ret){
        			if(ret.code == "success"){
        				that.allCount = ret.data.allCount;
        				that.payCount = ret.data.payCount;
        				that.putCount = ret.data.putCount;
        				that.receiveCount = ret.data.receiveCount;
        				that.sendCount = ret.data.sendCount;
        				that.closeCount = ret.data.closeCount;
        			}
        		})
        	},
        	logout:function(){
				localStorage.clear();
				API.loginOut(function(ret){});
				window.location.href = this.logoutUrl;
			},
			clearCookie:function(){
				var keys=document.cookie.match(/[^ =;]+(?=\=)/g); 
				if (keys) { 
				for(var i = keys.length; i--;) 
					document.cookie=keys[i]+'=0;expires=' + new Date( 0).toUTCString() 
				} 
			},
        	goOrder:function(tradeStatus){
				var account = localStorage.getItem("account");
				if(account != undefined && account != ""){
					window.location.href=this.orderUrl+"?tradeStatus="+tradeStatus;
				}else{
					window.location.href=getUcUrl()+'/login.htm';
				}
			},
        	 mobileAppShow:function(){
		  		this.isShow = true;
		  	 },
		  	 mobileAppHidden:function(){
		  		this.isShow = false;
		  	 },
        	jumpTo:function(name){
		  		this.$router.push({ name:name});
		  	},
        	toGoodsDetail:function(goodsCode){
				//this.$router.push({ name: 'goodsdetail', query:{goodsCode:goodsCode}});
				let routeData = this.$router.resolve({ path: '/goodsDetails', query: {goodsCode: goodsCode } });
				window.open(routeData.href, '_blank');
		  	},
		  	prePage:function(){
		  		if(this.currentPage > 1){
		  			 this.currentPage = this.currentPage -1;
		  			 this.adjustPageArray(this.currentPage);
		  			 this.getGoods();
		  		}
		  	},
		  	nextPage:function(){
		  		if(this.currentPage < this.totalPage){
		  			this.currentPage = this.currentPage +1;
		  			this.adjustPageArray(this.currentPage);
		  			this.getGoods();
		  		}
		  	},
		  	queryByPage:function(page){
	  			this.currentPage = page;
	  			this.adjustPageArray(this.currentPage);
	  			this.getGoods();
		  	},
		  	adjustPageArray:function(page){
		  		if(page == this.pageList[6] && (page+2) <= this.totalPage){
		  			this.pageList.push(page+1);
		  			this.pageList.push(page+2);
		  			this.pageList.shift();
		  			this.pageList.shift();
		  		}else if(page == this.pageList[6] && (page+1) == this.totalPage){
		  			this.pageList.push(page+1);
		  			this.pageList.shift();
		  		}else if(page == this.pageList[0] && page >= 3){
		  			this.pageList.unshift(page-1);
		  			this.pageList.unshift(page-2);
		  			this.pageList.pop();
		  			this.pageList.pop();
		  		}else if(page == this.pageList[0] && page == 2){
		  			this.pageList.unshift(page-1);
		  			this.pageList.pop();
		  		}
		  	},
		  	initPageArray:function(){
			 	var pageList = new Array();
			 	var totalPage = this.totalPage;
	         	for(var i=1;i<=totalPage;i++){
	     	 		if(i <= this.showItem){
	     	 			pageList.push(i);
	     	 		}
	         	}
				this.pageList = pageList;
			},
			clearUserDefined:function(){
				this.lower = '';
				this.upper = '';
			},
			userDefinedCondition:function(){
				this.lower = this.lower.trim();
				this.upper = this.upper.trim();
				var sortParams = '';
				if(this.lower != ''&&this.upper != ''){
					sortParams = this.lower + ',' + this.upper;
				}else if(this.lower == ''&& this.upper != ''){
					sortParams =  '0,' + this.upper;
				}else if(this.lower != ''&& this.upper == ''){
					sortParams = this.lower + ',';
				}
				this.chooseCondition('','amount',sortParams);
			},
		  	chooseCondition:function(event,type,sortParams){
		  		if(event != ''){
		  			var condText = event.target.innerText;
				    if(condText != "不限"){
		  				var condText = event.target.innerText;
					    if(jQuery("#choosedCond").find("span[condType='"+type+"']").length != 0){
		  					jQuery("#choosedCond").find("span[condType='"+type+"']").remove();
					    }
					    this.choosedCondItem.push({condName:condText,condType:type});
			  		}else{
			  			jQuery("#choosedCond").find("span[condType='"+type+"']").remove();
			  		}
			  		
			  		if(type == 'amount'){
		  				this.clearUserDefined();
			  		}
		  		}else{
		  			if(type == 'amount'){
		  				if(jQuery("#choosedCond").find("span[condType='"+type+"']").length != 0){
		  					jQuery("#choosedCond").find("span[condType='"+type+"']").remove();
					    }
			  		}
		  		}
		  		
		  		if(type == 'amount'){
	  				this.interval = sortParams;
		  		}else if(type == 'cat'){
		  			  this.catCode = sortParams;
		  		}else if(type == 'time'){
		  			  this.sortTime = sortParams;
		  		}
		  		this.getRecommendGoods();
				this.getGoods();
		  	},
		  	removeCondition:function(index,type){
		  			if(type == 'amount'){
		  				this.interval = "intervalAll";
			  		}else if(type == 'cat'){
			  			  this.catCode = "categoryAll";
			  		}else if(type == 'time'){
			  			  this.sortTime = "timeAll";
			  		}
		  			this.choosedCondItem.splice(index,1);
		  			this.getRecommendGoods();
					this.getGoods();
		  	},
		  	findGoods:function(){
		  			this.resetCond();
		  			this.getRecommendGoods();
					this.getGoods();
		  	},
		  	findShops:function(){
		  			this.$router.push({ name: 'shopsList', query:{sortParam:this.sortParam}});
		  	},
		  	sortGoods:function(sortCondition){
		  		 this.currentPage = 1;
		  		 this.sortCondition = sortCondition;
		  		 if(sortCondition == "saleAmount"){
		  		 			this.orderBy = "sale_number";
		  		 		  if(this.sortSaleAmount == ''){
		    					this.sortSaleAmount = "desc";
			    			}else if(this.sortSaleAmount == 'desc'){
			    				this.sortSaleAmount = "asc";
			    			}else if(this.sortSaleAmount == 'asc'){
			    				this.sortSaleAmount = "desc";
			    			}
			    			this.orderAsc = this.sortSaleAmount;
		  		 }
		  		 if(sortCondition == "publishTime"){
		  		 			this.orderBy = "gmt_create";
		  		 		  if(this.sortPublishTime == ''){
		    					this.sortPublishTime = "desc";
			    			}else if(this.sortPublishTime == 'desc'){
			    				this.sortPublishTime = "asc";
			    			}else if(this.sortPublishTime == 'asc'){
			    				this.sortPublishTime = "desc";
			    			}
			    			this.orderAsc = this.sortPublishTime;
		  		 }
		  		 if(sortCondition == "price"){
		  		 			this.orderBy = "unit_price";
		  		 		  if(this.sortPrice == ''){
		    					this.sortPrice = "desc";
			    			}else if(this.sortPrice == 'desc'){
			    				this.sortPrice = "asc";
			    			}else if(this.sortPrice == 'asc'){
			    				this.sortPrice = "desc";
			    			}
			    			this.orderAsc = this.sortPrice;
		  		 }
		  		 if(sortCondition == "defaultSort"){
		  		 		 this.orderBy = "";
		  		 		 this.orderAsc = "";
		  		 }
		  		 this.getGoods();
				 this.getRecommendGoods();
		  	},
		    getRecommendGoods:function(){
				var that = this;
				var interval = that.interval;
				var catCode = that.catCode;
				var cabinetId = "";
				var pageSize = 5;
				var isQueryAll = "n";
				var currentPage = 1;
				var orderBy = "sale_number";
				var orderAsc = "desc";
			    var shopCode = that.shopCode;
			    var sortTime = "";
			    var goodsName = encodeURI(that.sortParam);
			    var firstCatCode = that.firstCatCode;
			    var brandId = that.brandId;
			    var product_type="";
			    var order_type="";
				API.getGoodsList(cabinetId,catCode,interval,currentPage,orderBy,orderAsc,shopCode,sortTime,pageSize,isQueryAll,goodsName,firstCatCode,brandId,product_type,order_type,function(ret){
					if(ret.code == "success"){
						var goods = ret.data.goods;
						if(goods != undefined){
							for(var i=0;i<goods.length;i++){
								//商品图片
								var imgMiddle = goods[i].imgMiddle;
			                    if(imgMiddle.indexOf(";")!=-1){
			                    	imgMiddle=imgMiddle.split(";")[0];
			                    }
			                    imgMiddle = getImgUrl()+"/upload/show.htm?filePath="+imgMiddle;
			                    goods[i].imgMiddle = imgMiddle;
							}
						}
						that.recommendGoodsList = goods;
					}
				});
			 },
			 getGoods:function(){
				var that = this;
				var interval = that.interval;
				var catCode = that.catCode;
				var isQueryAll = "n";
			    var shopCode = that.shopCode;
				var cabinetId = "";
				var pageSize = 99999;
				var currentPage = that.currentPage;
				var orderBy = that.orderBy;
				var orderAsc = that.orderAsc;
		   		var sortTime = that.sortTime;
		   		var goodsName = encodeURI(that.sortParam);
		   		var firstCatCode = that.firstCatCode;
		   		var brandId = that.brandId;
		   		var seckillCode = that.seckillCode;
		   		API.getSeckillgoodsList(seckillCode,currentPage,pageSize,function(ret) {
					if(ret.code == "success"){
						var goods = ret.data.goods;
						that.totalItem = ret.data.totalItem;
						var totalPage = ret.data.totalPage;
						if(totalPage != undefined && totalPage != 0 && totalPage != that.totalPage ){
							that.totalPage = ret.data.totalPage;
							that.initPageArray();
						}else if(totalPage != undefined && totalPage == 0){
							that.totalPage = 1;
							that.initPageArray();
						}
						if(goods != undefined){
							for(var i=0;i<goods.length;i++){
								//商品图片
								var imgMiddle = goods[i].imgMiddle;
			                    if(imgMiddle.indexOf(";")!=-1){
			                    	imgMiddle=imgMiddle.split(";")[0];
			                    }
			                    imgMiddle = getImgUrl()+"/upload/show.htm?filePath="+imgMiddle;
			                    goods[i].imgMiddle = imgMiddle;
			                    
			                    if(firstCatCode=='spike'){
			                    	
	 						var marketPrice=JSON.parse(goods[i].attrValue).marketPrice;
	 						var saleTimeStr=JSON.parse(goods[i].attrValue).saleTimeShow;
	 						var saleEndTimeStr=JSON.parse(goods[i].attrValue).saleEndTimeShow;
	 						if(marketPrice!=undefined && marketPrice!=""){
	                    		goods[i].marketPrice=marketPrice;
			 				}else{
			 					goods[i].marketPrice=goods[i].unitPrice;
			 				}
			 				if(saleEndTimeStr!=undefined&&saleEndTimeStr!=''){
			 					saleEndTimeStr=saleEndTimeStr.replace(/-/g,"/");
								var saleEndDate = new Date(saleEndTimeStr);
								
								saleTimeStr=saleTimeStr.replace(/-/g,"/");
								var saleDate = new Date(saleTimeStr);
								
			 				}

			                    }
							}
						}
						that.goodsList = goods;
						if(!that.isInit){
							that.isInit = true;
							that.initPageArray();
						}
					}
				});
			 },
			getShoppingCartNum:function(shopCode){
        		var that=this;
        		API.getShoppingCartNum(function(ret){
        			if(ret.code == "success"){
        				that.shoppingCartNum = ret.data.shoppingCartNum;
        			}
        		});
        	},
        	getShoppingCartList:function(){
        		var that=this;
        		API.getShoppingCartList(function(ret){
					 if(ret.code == "success"){
					 	that.boList = ret.data.boList;
					 	var totalCount = 0;
					 	var bos = new Array();
					 	bos = ret.data.boList;
					 	var money = 0;
					 	for(var i =0; i<bos.length;i++){
					 		var imgSmall = bos[i].imgSmall;
		                    if(imgSmall.indexOf(";")!=-1){
		                    	imgSmall=imgSmall.split(";")[0];
		                    }					 		
					 		bos[i].imgSmall = getImgUrl()+"/upload/show.htm?filePath="+imgSmall;
					 		money = money + bos[i].goodsPrice * bos[i].goodsNumber;
					 		totalCount = totalCount + bos[i].goodsNumber;
					 	}
					 	that.sumMoney = money;
					 	that.count = totalCount;
					 	
					 }
        		})
        	},
        	deleteGoods:function(goodsCode){
        		var that=this;
        		API.deleteGoods(goodsCode, function(ret){
        			if(parseResult(ret, null, false)) {
						jQuery("#" + goodsCode + "_cart_pro").remove();	
					}
        		})
        	},
        	goIndex:function(){
		  		this.$router.push({name:'index'});
		  	},
        	getMoreCatGoods:function(catCode,catNameCn){
        		this.catNameCn = catNameCn;
        		this.resetCond();
        		this.sortParam = "";
        		this.firstCatCode = catCode;
        		this.sortParam = "";
		  	 	this.getRecommendGoods();
				this.getGoods();
		  	},
		  	getCatGoods:function(catCode,catNameCn){
		  		this.catNameCn = catNameCn;
		  	 	this.resetCond();
        		this.sortParam = "";
        		this.catCode = catCode;
        		this.firstCatCode = "";
        		this.sortParam = "";
		  	 	this.getRecommendGoods();
				this.getGoods();
		  	},
        	resetCond:function(){
        		this.interval = "intervalAll";
        		this.catCode = "categoryAll";
        		this.sortTime = "timeAll";
        		this.firstCatCode = "";
        		this.orderBy = "";
        		this.orderAsc = "";
        		jQuery("#choosedCond").html("");
        	},
        	getSeckillActivityList: function() {
				var that = this;
				API.getSeckillActivityList(function(ret) {
					if(ret.code == "success" && ret.data != undefined) {
						that.currentDate = new Date(dateFormat(ret.data.currentTime + "").replace(/-/g, "/"));
						that.secKillBo = ret.data.secKillBo;
						that.secKillBo.activityBeginTime = dateFormat(that.secKillBo.activityBeginTime+"");
						that.secKillBo.activityEndTime = dateFormat(that.secKillBo.activityEndTime+"");
						that.activityBeginTime = that.secKillBo.activityBeginTime;
						that.activityEndTime = that.secKillBo.activityEndTime;
						that.seckillCode = ret.data.secKillBo.activityCode;
						var secKillList = ret.data.secKillList;
						for(var i = 0; i < secKillList.length; i++){
							secKillList[i].activityBeginTime = dateFormat(secKillList[i].activityBeginTime+"");
							secKillList[i].activityEndTime = dateFormat(secKillList[i].activityEndTime+"");
						}
						that.secKillList = secKillList;
						that.seckillGoods = ret.data.seckillGoods;
						that.getGoods();
					}
				});
			},
			chooseActivity: function(seckillCode,activityBeginTime,activityEndTime) {
				//				this.getCategoryList(catCode);
				this.seckillCode = seckillCode;
				this.activityBeginTime=activityBeginTime;
				this.activityEndTime=activityEndTime;
				var page={
					'items': [],
					'totalPage': 0,
					'currentPage': 1,
					'nextPage': 1
				} //重置分页数据
//				 page = this.page; 
//				page.nextPage = 1;
				this.page = page;
				this.getGoods(page);
			},
			//判断是否在活动时间内
			compareActTime: function(actBeginTime,actEndTime) {
				var that = this;
				if(that.currentDate==null||that.currentDate==undefined||actBeginTime==null||actBeginTime==undefined
					||actEndTime==null||actEndTime==undefined){
					return false;
				}else{
					if(compareDate(actBeginTime, that.currentDate) <= 0 && compareDate(actEndTime, that.currentDate) >= 0){
						return true;
					}else{
						return false;
					}
				}
			},
  		},
        ready:function(){
        	
		},
		beforeDestroy () {
			var that=this;
			if(that.firstCatCode == 'spike'){
     			window.clearInterval(this.computeFlag);
     		}
  		},
		mounted(){
			window.scrollTo(0, 0);
//			this.$refs.navComp.getCat();
			var account = localStorage.getItem("account");
			if(account != undefined && account != ""){
				this.isLogin = true;
				this.account = account;
			}
			this.userCenterUrl = getUcUrl() + '/index/default.htm';
			this.loginUrl = getUcUrl() + '/login.htm';
//			this.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm';
			this.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
			this.logoutUrl = getUcUrl() + '/logout.htm';
			this.aboutUsUrl = getAboutUsUrl();
			this.indexUrl = getIndexUrl();
			this.orderUrl = getEmallUrl() + '/orderManage/myOrderList.htm';
		
			var sortParam = this.$route.query.sortParam;
			var firstCatCode = this.$route.query.firstCatCode;
			var shopCode = this.$route.query.shopCode;
			var catCode = this.$route.query.catCode;
			var catNameCn = this.$route.query.catNameCn;
			var brandId = this.$route.query.brandId;
			var brandName = this.$route.query.brandName;
			
			if(sortParam != undefined){
				this.sortParam = sortParam;
			}
			if(firstCatCode != undefined){
				this.firstCatCode = firstCatCode;
			}
			if(shopCode != undefined){
				this.shopCode = shopCode;
			}
			var that=this;
			
//			if(catCode != undefined){
//				this.catCode = catCode;
//				this.getCatGoods(this.catCode);
//			}else{
//				this.getRecommendGoods();
//				this.getGoods();
//			}
			if(catNameCn != undefined){
				this.catNameCn = decodeURI(catNameCn);;
			}
			if(brandId != undefined){
				this.brandId = brandId;;
			}
			if(brandName != undefined){
				this.brandName = brandName;;
			}
			this.getSeckillActivityList();
		}
	}
</script>

<style scoped>
	.current_page{
		border: solid 1px #ff6600;
	}
	.demensional_code{
		height: 100px;
	    width: 100px;
	    z-index: 99;
	    background-color: gainsboro;
	    position: absolute;
	    right: 45px;
	}
	.price-wrap{
		position: absolute;
	}
	.price-tool{
		display: none;
		background: #fff;
		margin-top: -37px;
		margin-left: -10px;
		padding-top:40px;
		width:calc(100% + 20px);
		border:1px solid #999;
		box-shadow:0 0 10px rgba(0,0,0,.5);	
		color:#ddd;		
		overflow:hidden;	
	}
	.price-tool-btn{
		overflow: hidden;
		padding:10px;
	}
	.price-tool-btn a{
		display:block;
		color:#0069B7;
		padding:3px 8px;
	}
	.price-tool-btn span{
		display:block;
		background: #f7f7f7;
		border:1px solid #dcdcdc;
		color: #333;
		padding:3px 8px;
		cursor:pointer;
	}
	.input-wrap input{
		width: 80px;
		border:1px solid #dcdcdc;
		height:25px;
		border-radius:0;
		outline: none;
		text-indent:10px;
	}
	.price-wrap:hover .price-tool{
		display: block;
	}
	*{margin: 0px;padding: 0px;}
        .left{float: left}
        .right{float: right}
        .clear{clear: both;}
        li{
            display: inline-block;
            list-style: none;
        }
        .head{
            width: 100%;
            height: 48px;
            background: #e63140;
            color: #ffffff;
            display: flex;
        }
        .head>div{
            width: 1075px;
            margin: 0 auto;
        }
        .head h2{
            margin-left: 10px;
            height: 48px;
            line-height: 48px;
            display: inline-block;
        }
             
        .head .headLeft{
            width: 200px;
            display: inline-block;
            flex: 2;
            margin-left: 111px;
            height: 48px;
            line-height: 48px;
        }
        .headLeft a{
        	font-size: 15px;
            color: #ffffff;
            text-decoration: none;
            text-align: center;
            display: inline-block;
            width: 80px;
            height: 30px;
            line-height: 30px;
        }
        .headLeft a:hover{
            background: #ffffff;
            color: #e63140;
            border-radius: 10px;
            display: inline-block;
            text-align: center;
            width: 80px;
            height: 30px;
            line-height: 30px;
        }
        .headRight{flex: 1;margin-right: 10px;}
        .headRight li{
            height: 48px;
            line-height: 48px;
            font-size: 12px;
            margin-left: 20px;
        }
        .headRight img{
            display: inline-block;
            margin: 10px auto;
            vertical-align: middle;
        }
        
        #navTime{
        	width: 1055px;
        	position: relative;
        	margin: 0 auto;
        }
        
        .navTime{
        	cursor: pointer;
        	position: relative;
            width: 100%;
            height: 66px;
            background: #2C3847;
            color: #787F88;
            padding: 7px 0px;
             width: 938px;
            margin: 0 auto;
            overflow: hidden;
        }
        .navTime>ul{
           /*padding:0px 50px ;*/
        }
        
        .navTime .hour{font-weight: bold;}
        .navTime .start{font-size: 12px;}
        .navTime li{
        	cursor: pointer;
            width: 100px;
            text-align: center;
        }
        
        #navTime .prev-bnt{
        	left: 0px;
        }
        
        #navTime .next-bnt{
        	right: 0px;
        }
        
        #navTime .change-bnt{
        	color: #fff;
        	display: none;
        	text-align: center;
        	line-height: 50px;
        	display: block;
		    width: 30px;
		    height: 50px;
		    position: absolute;
		    top: 50%;
		    margin-top: -25px;
		    background-color: #b74343;
        }
        
        #navTime .btn_nav{
        	display: none;
        }
        .shopWarp{
            width: 100%;
            background: #F7F7F8;
        }
        .shopWarp li{
            background: #ffffff;
            border-radius: 5px;
            margin: 5px;
            border: 1px solid #ffffff;
            width: 503px;
            padding: 10px;
            position: relative;
            height: 277px;
        }
        .shopWarp img{
            display: block;
            float: left;
            margin:  auto 0px;
            height: 255px;
    		width: 255px;
        }
        .shopWarp li:hover{
            border: 1px solid #e63140;
        }
        .nowImg{
            width: 50px;
        }
        .right{margin-left: 20px}
        .rightTitle{color: gray;font-size: 16px;width: 224px;word-wrap:break-word;}
        .rightdetail{
            color: #EF807C;
            font-size: 15px;
            word-wrap:break-word;
        }
        .right .currentPrice1{
            color: #fd6862;
            font-weight: bolder;
            font-size: 32px;

        }
        .right .originalPrice1{
            font-size: 14px;
            color: gainsboro;
            text-decoration: line-through;

        }
        .priceleft,.priceright{margin-top: 10px;margin-bottom: 10px}
        .priceleft,.priceright{
            position: absolute;
            bottom: 50px;
        }
        .priceright{
            right: 10px;
        }
        .link-btn{
            border-color: #fcdcdd;
            color: #fc353a;
            background-color: #fcdcdd;
            border-radius: 4px;
            font-size: 18px;
            line-height: 38px;
            text-align: center;
            width: 82px;
            height: 38px;
        }
        .num span{
            color: gainsboro;
            margin-right: 2px;
            font-size: 15px;
        }
        .num span:nth-child(1){
            float: right;
        }
        .shopWarp .down{
            width: 224px;
            height: 15px;
            border: 1px solid #EF807C ;
            border-radius: 10px;
            margin-top: 4px;
        }
        .shopWarp .down div{
            width: 100px;
            height: 15px;
            background: #f99693;
            border-radius: 10px 0px 0px 10px;
        }
        .shopBox {width: 1075px;margin: 0px auto;}
        .progress{
            position: absolute;
            bottom: 15px;
        }
        .cur {
        color: #878787;
        font-weight: 700;
	    }
	    
	    .nav_kq{
	    	color: #666263;
	    }

</style>



// WEBPACK FOOTER //
// src/page/goods/seckillList.vue?e7b3af24